<template>
    <div class="account-data-details">
        <div class="details-top">
            <el-breadcrumb separator-class="el-icon-arrow-right" class="interactive-breadcrumb">
                <el-breadcrumb-item class="first">账号管理</el-breadcrumb-item>
                <el-breadcrumb-item class="second">抖音账号数据详情</el-breadcrumb-item>
            </el-breadcrumb>
            <el-button class="blue-btn" @click="toBack">返回</el-button>
        </div>

        <div class="details-bottom">
            <AccountDetail :initId="Number($route.query.id)"></AccountDetail>
        </div>
    </div>
</template>

<script>
import AccountDetail from "../../../components/account/AccountDetail.vue";

export default {
    name: "AccountDataDetails",
    data() {
        return {};
    },

    components: {
        AccountDetail,
    },

    methods: {
        toBack() {
            this.$router.go(-1);
        },
    },
};
</script>

<style lang="scss" scoped>
.account-data-details {
    display: flex;
    flex-direction: column;
    height: 100%;

    .details-top {
        display: flex;
        position: relative;

        .blue-btn {
            padding: 8px 25px;
            font-size: 14px;
            position: absolute;
            right: 0;
            bottom: 10px;
        }
    }

    .details-bottom {
        position: relative;
        min-height: calc(100vh - 138px);
    }
}
</style>
